<template>
  <div id="app">
      <Header v-if="!is404 && !showHeaderFooter"></Header>
      <div class="dis-flex">
        <router-view/>
        <Footer v-if="!is404 && !showHeaderFooter"></Footer>
      </div>
  </div>
</template>

<script>
import Header from './components/header/Header'
import Footer from './components/footer/Footer'
export default {
  name: 'App',
  data(){
    return {
    }
  },
  computed: {
    showHeaderFooter() {
      return this.$route.fullPath.indexOf('anniversary') > -1;
    },
    is404() {
      return this.$route.fullPath.indexOf('404') > -1;
    }
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll); // 监听滚动事件
  },
  methods: {
    handleScroll() {
      let myElement = document.querySelector('.header');
      if (window.pageYOffset > 0){
        myElement.style.boxShadow = '0px 10px 10px 1px rgba(0,0,0,0.05)';
      }else{
        myElement.style.boxShadow = 'none';
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听器
  }
}
</script>

<style>
@import '../static/css/reset.css';
body{
  background: #F2F2F2;
}
#app {
  padding-top: 120px;
  font-family: 'Noto Sans SC', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
ul,li{
  list-style: none;
}
.dis-flex{
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}
.header{
  /* background: blue; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue